import LoanModel from '../models/school-loans.model';
import Product from '../models/product.model';

let storeContent = utils.generateStore({
	LoanModel,
	loan_transactions: [],
	school_loans: [],
	selected_loan: null,
	loan_details: null,
	showViewLoan: false,
	activeTabLoan: 1,
	school_loan_details_table: [],
	loan_notifications: [],
	loan_payment_schedules: [],
	Product,
});

export default {
	state() {
		return { ...storeContent.state };
	},
	getters: {
		...storeContent.getters,
	},
	mutations: {
		...storeContent.mutations,
	},
	actions: {
		openTabLoan(ctx, page) {
			ctx.commit('activeTabLoan', page);
		},
		async fetchSchoolsInvoices(ctx) {
			try {
				let res = await api.fetchEndpointSecure(
					{
						resource: 'invoice_financing',
						action: 'applications',
						data: {},
					},
					'/client',
				);

				if (res.result.loan_applications) {
					ctx.commit('school_loans', res.result.loan_applications);
				}

				// ctx.commit('school_loans', [
				//    {
				//       currency: 'KES',
				//       status: 'Processing',
				//       bank: 'Equity Bank',
				//       bank_code: 'EQBLKE',
				//       loan_ref: 'JKTE66377HDHHD',
				//       created_at: '2021-07-21T23:13:41.741Z',
				//       total_amount: 300000,
				//    },
				// ]);
			} catch (err) {
				throw err;
			}
		},
		async submitReview(ctx, payload) {
			try {
				ctx.commit('loading', true);
				let data = payload.ref.formData_;

				if (await payload.ref.isValid()) {
					let res = await api.fetchEndpointSecure(
						{
							resource: 'loan',
							action: 'review',
							data: {
								loan_account_system_ref:
									ctx.getters.loan_details
										.application_system_ref,
								rating: data.rating,
								review: data.review,
							},
						},
						'/client',
					);

					ctx.commit('showAddReviews', false);
					$notify(
						'success',
						'Review Submitted',
						`Your review has been successfully submitted`,
						10,
					);
				}
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
			ctx.commit('loading', false);
		},
		async fetchProductReviews(ctx) {
			try {
				Event.$emit('loader:show', true);

				let res = await api.fetchEndpointSecure(
					{
						resource: 'loan',
						action: 'list_reviews',
						data: {
							loan_account_system_ref:
								ctx.getters.loan_details.application_system_ref,
						},
					},
					'/client',
				);

				ctx.commit('product_reviews', res.result.intermediary_reviews);

				Event.$emit('loader:show', false);
			} catch (err) {
				Event.$emit('loader:show', false);
				throw err;
			}
		},
		async fetchLoanDetailsTable(ctx) {
			try {
				// let res = await api.fetchEndpointSecure(
				//   {
				//     resource: 'ipf_product',
				//     action: 'loan_account_details',
				//     data: {
				//       account_number: ctx.getters.ipf.ipf_details.ipf_loan_account,
				//     },
				//   },
				//   '/client'
				// );

				ctx.commit('school_loan_details_table', [
					{
						title: 'Principle',
						original: 1000,
						paid: 300,
						written_off: 20,
						overdue: 100,
						outstanding: 680,
					},
					{
						title: 'Interest',
						original: 1000,
						paid: 300,
						written_off: 20,
						overdue: 100,
						outstanding: 680,
					},
					{
						title: 'Charges',
						original: 1000,
						paid: 300,
						written_off: 20,
						overdue: 100,
						outstanding: 680,
					},
					{
						title: 'Total',
						original: 1000,
						paid: 300,
						written_off: 20,
						overdue: 100,
						outstanding: 680,
					},
				]);
			} catch (err) {
				throw err;
			}
		},
		async payLoan(ctx) {
			try {
				ctx.commit('loading', true);

				if (await payload.ref.isValid()) {
					// let res = await api.fetchEndpointSecure(
					//    {
					//    resource: 'loan',
					//    action: 'repayment',
					//    data: {
					//       account_number: ctx.getters.ipf.ipf_details.ipf_loan_account,
					//       amount: payload.ref.formData_.amount,
					//    },
					//    },
					//    '/client'
					// );

					ctx.commit('showViewIPF', false);
					// $notify('success',`Loan Payment Success - ${res.result.tran_ref}`,`Loan repayment of ${payload.ref.formData_.amount} paid`);
				}

				ctx.commit('loading', false);
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
		},
		async fetchLoanDetails(ctx, loan) {
			try {
				let res = await api.fetchEndpointSecure(
					{
						resource: 'loan',
						action: 'application',
						data: {
							application_system_ref: loan.application_system_ref,
						},
					},
					'/client',
				);

				ctx.commit('loan_details', res.result.loan_application_details);

				ctx.commit('loan_notifications', [
					{
						created_at: '2021-06-01T18:59:30.712Z',
						subject: 'Loan Payment',
						notification:
							'Loan payment was made on <b>6th Aug 2021</b>. Amount Paid was <b>KES 12,000</b>.',
					},
					{
						created_at: '2021-06-01T18:59:30.712Z',
						subject: 'Loan Payment',
						notification:
							'Loan payment was made on <b>6th Aug 2021</b>. Amount Paid was <b>KES 12,000</b>.',
					},
					{
						created_at: '2021-06-01T18:59:30.712Z',
						subject: 'Loan Payment',
						notification:
							'Loan payment was made on <b>6th Aug 2021</b>. Amount Paid was <b>KES 12,000</b>.',
					},
					{
						created_at: '2021-06-01T18:59:30.712Z',
						subject: 'Loan Payment',
						notification:
							'Loan payment was made on <b>6th Aug 2021</b>. Amount Paid was <b>KES 12,000</b>.',
					},
				]);

				ctx.commit('loan_transactions', [
					{
						tran_ref: 'HJAJTEYYY37388I9',
						tran_amount: 2000,
						paymentDate: '2021-08-12T18:59:30.712Z',
					},
					{
						tran_ref: 'HJAJTEYYY37388I9',
						tran_amount: 2100,
						paymentDate: '2021-08-12T18:59:30.712Z',
					},
					{
						tran_ref: 'HJAJTEYYY37388I9',
						tran_amount: 4200,
						paymentDate: '2021-08-12T18:59:30.712Z',
					},
					{
						tran_ref: 'HJAJTEYYY37388I9',
						tran_amount: 10000,
						paymentDate: '2021-08-12T18:59:30.712Z',
					},
					{
						tran_ref: 'HJAJTEYYY37388I9',
						tran_amount: 19000,
						paymentDate: '2021-08-12T18:59:30.712Z',
					},
				]);

				ctx.commit('loan_payment_schedules', [
					{
						paymentToPrinciple: 1243.236,
						paymentToInterest: 2000,
						feesDue: 300,
						feePayment: 300,
						penaltiesDue: 10,
						principalPayment: 12000,
						interestPayment: 7212,
						penaltyPayment: 125,
						paymentDate: '2021-08-12T18:59:30.712Z',
						status: 'paid',
					},
					{
						paymentToPrinciple: 1243.236,
						paymentToInterest: 2000,
						feesDue: 300,
						feePayment: 300,
						penaltiesDue: 10,
						principalPayment: 12000,
						interestPayment: 7212,
						penaltyPayment: 125,
						paymentDate: '2021-08-12T18:59:30.712Z',
						status: 'paid',
					},
					{
						paymentToPrinciple: 1243.236,
						paymentToInterest: 2000,
						feesDue: 300,
						feePayment: 300,
						penaltiesDue: 10,
						principalPayment: 12000,
						interestPayment: 7212,
						penaltyPayment: 125,
						paymentDate: '2021-08-12T18:59:30.712Z',
						status: 'paid',
					},
				]);
			} catch (err) {
				throw err;
			}
		},
		async viewSchoolLoan(ctx, loan) {
			try {
				Event.$emit('loader:show', true);
				await ctx.commit('selected_loan', loan);
				await ctx.dispatch('fetchLoanDetailsTable');
				await ctx.dispatch('fetchLoanDetails', loan);
				await ctx.commit('showViewLoan', true);
				Event.$emit('loader:show', false);
			} catch (err) {
				Event.$emit('loader:show', false);
				throw err;
			}
		},
		async fetchData(ctx) {
			try {
				Event.$emit('loader:show', true);
				await ctx.dispatch('fetchSchoolsInvoices');
				Event.$emit('loader:show', false);
			} catch (err) {
				Event.$emit('loader:show', false);
				throw err;
			}
		},
	},
};
